import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import OtherData from '../../../dossiers/common/OtherData'
import { validateOtherData } from '../../../../util/validationFunctions'
import { dossierTypes as dossierTypesConstant } from '../../../../constants/dossier/common/dossierTypes'

class DataOtherDataFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  saveData (values) {
    let dossierList = this.props.dossiers.map(x => { return x.dossierId })
    this.props.actions.setOperateDataOtherDataFleetProcess(
      dossierList,
      values.dossierCompleteOtherDataComponent,
      this.props.fleet.fleetId,
      this.props.dossiers[0].dossierSubTypeId,
      () => this.props.actions.closeDataOtherDataFleetModal()
    )
  }

  componentDidUpdate () {}

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.showModal && !prevProps.showModal) {
      this.props.initialize()
      this.props.actions.fetchOperateDataFleetModalsPermissions(
        this.props.fleet.dossierSubType,
        this.props.organizedUnitId,
        this.props.stageId
      )
      this.props.actions.getOtherDataFleet(this.props.fleet.fleetId, this.props.organizedUnitId, this.props.dossiers[0].dossierSubTypeId)
    }
    return null
  }

  render () {
    const {
      t, showModal, handleSubmit, pristine, change, componentConfiguration, dossier, fleet,
      actions: {
        openCommonModal, closeDataOtherDataFleetModal, setActiveSection
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.OTHER_DATA.'

    if (showModal && componentConfiguration) {
      return (
        <Modal id="dataOtherDataFleetModal" className="_nf fleet-created-select-modal languages-modal" show={showModal} onHide={closeDataOtherDataFleetModal} backdrop={'static'}>
          <form className='formDataSalesFleet' autoComplete="off" onSubmit={handleSubmit((values) => this.saveData(values))}>
            <Modal.Header closeButton onHide={this.props.actions.closeActionDataModal}>
              <Modal.Title>  <i className="ico-sales" />{t(`${tKey}TITLE_PANEL`)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <OtherData
                t={t}
                pristine={pristine}
                handleToUpdateComponent = {() => false}
                historical={false}
                dossierId={this.props.dossier.dossierId}
                combos={this.props.combos}
                open={true}
                componentConfiguration={componentConfiguration}
                dossier={dossier}
                dossierType={fleet?.isPurchase ? dossierTypesConstant.purchase : dossierTypesConstant.sales}
                isFleet={true}
                showEconomicPlan={true}
                actions={{
                  change,
                  openCommonModal,
                  setActiveSection
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Col sm={12} className='flexInLine al-C'>
                <Button
                  id="dataOtherDataFleet_btn_search"
                  className="_Btn new"
                  type='submit'
                  disabled={this.props.pristine}>
                  {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.SAVE')}
                </Button>
                <Button
                  id='btn-close-fleet-created-select-charge-modal'
                  className="_Btn cancel"
                  onClick={() => closeDataOtherDataFleetModal()}>
                  {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.EXIT')}
                </Button>
              </Col>
            </Modal.Footer>
          </form>
        </Modal>

      )
    } else {
      return null
    }
  }
}

const validate = (values, props) => {
  let errors = {}
  const dossierOtherDataComponent = validateOtherData(values, props)
  if (Object.keys(dossierOtherDataComponent).length > 0) {
    errors.dossierOtherDataComponent = dossierOtherDataComponent
  }
  return errors
}

export default reduxForm({
  form: 'dataOtherDataFleetModal',
  validate
})(DataOtherDataFleetModal)
